import React from 'react';
import PropTypes from 'prop-types';
import { arc } from 'd3-shape';
import { scaleLinear } from 'd3-scale';
import style from './style/outcomegauge.scss';

const OutcomeGauge = ({
    amountOfArcs,
    amountOfColoredArcs,
    outcomeText,
    classes
}) => {
    if (!amountOfArcs) {
        return null;
    }

    const getRanges = () => {
        const spread = 1 / amountOfArcs;

        const toReturn = [];

        for (let i = 0; i < amountOfArcs; i++) {
            toReturn.push({
                min: i * spread,
                max: (i + 1) * spread
            })
        }

        return toReturn;
    };

    const ranges = getRanges();

    const angleScale = scaleLinear()
        .domain([0, 1])
        .range([0, Math.PI * 2])
        .clamp(true);

    const svgElements = [];

    ranges.forEach((range, i) => {
        const levelArc = arc()
            .innerRadius(1)
            .outerRadius(0.83)
            .startAngle(angleScale(ranges[i].min))
            .endAngle(angleScale(ranges[i].max))
            .padAngle(0.02)();

        svgElements.push(<path key={i} d={levelArc} className={`${style.defaultColor} ${i < amountOfColoredArcs ? classes.color : ''}`} />);
    });

    return (
        <div className={`${style.outcomeGauge} ${classes.root}`}>
            <svg viewBox={[-1, -0.5, 2, 1].join(' ')} className={style.arcs}>
                <>
                    {svgElements}
                </>
            </svg>
            <div className={`${style.outcomeText} ${classes.outcomeText}`}>
                <h4>{outcomeText}</h4>
            </div>
        </div>
    );
}

export default OutcomeGauge;

OutcomeGauge.propTypes = {
    amountOfArcs: PropTypes.number.isRequired,
    amountOfColoredArcs: PropTypes.number.isRequired,
    outcomeText: PropTypes.string,
    classes: PropTypes.shape({
        root: PropTypes.string,
        color: PropTypes.string.isRequired,
        outcomeText: PropTypes.string
    })
};
